import { Component, Input } from '@angular/core';

@Component({
    selector: 'avenir-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  @Input() testIdPrefix?: string;
  currentYear: number = new Date().getFullYear(); // Get the current year

}
